import { Subscription } from 'rxjs';
import { Component, ViewChild, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatPaginator, MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { BreakpointObserver } from '@angular/cdk/layout';
import { MatTableDataSource } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { GeneralService } from '../../shared/services/general.service';
import { LoadGeneralComponent } from '../../shared/components-generals/load-general/load-general.component';
import { CardLocations } from '../../shared/components-generals/card-product/card-product';
import { NgClass, AsyncPipe } from '@angular/common';
import { InputGeneral } from '../../shared/inputs/input-general/input-general';
import { FormControl } from '@angular/forms';
import { Product } from '../../shared/models/products-model/products.model';
import { ProductsService } from '../../shared/services/products.service';
import { LocationDetailResponse } from '../../shared/models/location-model/location.model';
import { InputGeneralSelectComponent } from '../../shared/inputs/input-general-select/input-general-select.component';
import { O } from '@angular/cdk/keycodes';
import { TicketService } from '../../shared/services/ticket.service';
import { Ticket, TicketSupply } from '../../shared/models/ticket-model/tiket.model';

@Component({
  selector: 'app-products',
  imports: [
    MatPaginator,
    MatButtonModule,
    LoadGeneralComponent,
    CardLocations,
    NgClass,
    AsyncPipe,
    InputGeneralSelectComponent,
  ],
  providers: [
    {
      provide: MatPaginatorIntl,
      // Instanciamos el servicio y le borramos el texto en 1 sola línea
      useValue: Object.assign(new MatPaginatorIntl(), { itemsPerPageLabel: '' }),
    },
  ],
  templateUrl: './products.html',
})
export class Products {
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  public isLoading = false;
  public isLoadingTicket = false;
  public mobile = false;
  public locationSite: any[] = [];
  public totalItems = 0;
  public pageIndex = 0;
  public pageSize = 8;
  public buttonFilter: string = '';
  private breakpointSubscription!: Subscription;
  private inputSubscription!: Subscription;
  public productsDataSource = new MatTableDataSource<Product>([]);
  public productsFavorites: Product[] = [];
  public address: FormControl = new FormControl<LocationDetailResponse | null>(null);
  public dataSourceLocations = new MatTableDataSource<any>([]);
  @Input() productInCar: { [key: string]: Product } = {};
  @Input() locationDetail: LocationDetailResponse | null = null;
  @Input() locationDetailArray: LocationDetailResponse[] = [];

  constructor(
    public dialog: MatDialog,
    private generalService: GeneralService,
    private productsService: ProductsService,
    public ticketService: TicketService,
    private breakpointObserver: BreakpointObserver,
  ) {}

  ngOnInit(): void {
    this.checkScreenSize();
    this.getProducts(0);
    this.address.setValue(this.locationDetail);
    this.inputSubscription = this.address.valueChanges.subscribe(
      (value: LocationDetailResponse) => {
        this.productsService.emitLocation.emit(value);
        localStorage.setItem('location', JSON.stringify(value));
        this.productsFavorites = [];
        this.getClosedTicket({
          Page: 1,
          PageSize: 10,
          SearchField: 'LocationKey',
          SearchFieldValue: value?.Key || '',
        });
      },
    );
    this.getClosedTicket({
      Page: 1,
      PageSize: 10,
      SearchField: 'LocationKey',
      SearchFieldValue: this.locationDetail?.Key || '',
    });
  }

  ngOnDestroy() {
    if (this.breakpointSubscription) {
      this.breakpointSubscription.unsubscribe();
    }
    if (this.inputSubscription) {
      this.inputSubscription.unsubscribe();
    }
  }

  private checkScreenSize(): void {
    this.breakpointSubscription = this.breakpointObserver
      .observe(['(max-width: 1024px)'])
      .subscribe((result) => {
        this.mobile = result.matches;
      });
  }

  public onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.getProducts(event.pageIndex);
  }

  public getProducts(pageIndex: number, SearchField?: string, SearchFieldValue?: string): void {
    this.pageIndex = pageIndex;
    this.productsDataSource.data = [];
    this.productsService
      .getSupply({
        Page: this.pageIndex + 1,
        PageSize: this.pageSize,
        partnerId: '1',
        SearchField: SearchField,
        SearchFieldValue: SearchFieldValue,
      })
      .subscribe((data) => {
        if (data) {
          this.productsDataSource.data = data.Data.Items;
          console.log('data', this.productsDataSource.data);
          this.totalItems = data.Data.TotalCount;
        }
      });
  }

  public getClosedTicket(params: {
    Page: number;
    PageSize: number;
    SearchField?: string | null;
    SearchFieldValue?: string | null;
  }): void {
    this.isLoadingTicket = true;
    this.ticketService.getClosedTicket(params).subscribe((response) => {
      const item = response?.Data.Items.find((i) => i.WorkFlowType === 'Solicitud Helado');
      if (item) {
        this.ticketService.ticketPendingSupply(item.Id).subscribe((supplyResponse) => {
          this.productsFavorites =
            supplyResponse?.Data.map((ticketSupply) => ({
              ...ticketSupply.Supply,
              added: false,
              amount: ticketSupply.Quantity,
            })) || [];
          this.isLoadingTicket = false;
          console.log('productsFavorites', this.productsFavorites);
        });
      } else {
        this.isLoadingTicket = false;
      }
    });
  }
}
